import React from "react";
import { motion } from "framer-motion";
import acticleIcon from "../../Assets/joinNow.png";
import img1 from "../../Assets/img.png";
import img2 from "../../Assets/img (1).png";
import img3 from "../../Assets/img (2).png";
import img4 from "../../Assets/img (3).png";
import { FiArrowUpRight } from "react-icons/fi";

const Articles = () => {
  const articlesData = [
    {
      id: 1,
      image: img1,
      title: "Business Strategy Planning",
      description:
        "Duise sagettis rosend accumsas magna onest curos adipiscine contacting the agency secondar",
    },
    {
      id: 2,
      image: img2,
      title: "Data Analysis Services",
      description:
        "Duise sagettis rosend accumsas magna onest curos adipiscine contacting the agency secondar",
    },
    {
      id: 3,
      image: img3,
      title: "Machine Learning Models",
      description:
        "Duise sagettis rosend accumsas magna onest curos adipiscine contacting the agency secondar",
    },
    {
      id: 4,
      image: img4,
      title: "Custom Artificial Solutions",
      description:
        "Duise sagettis rosend accumsas magna onest curos adipiscine contacting the agency secondar",
    },
  ];

  return (
    <motion.div
      className="py-4 sm:py-6 md:py-8 lg:py-10 xl:py-12 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 bg-white"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7 }}
    >
      <div className="mx-auto">
        {/* Header Section */}
        <div className="flex flex-col items-center text-center mb-1 sm:mb-2 md:mb-3 lg:mb-4 xl:mb-5">
          <div className="flex items-center gap-1 mb-4 sm:mb-6 px-3 py-1 bg-white/50 shadow-sm">
            <img
              src={acticleIcon}
              alt="Articles Icon"
              className="w-full h-auto"
            />
            <span className="text-[10px] font-bold tracking-[0.2em] text-brandDark">
              ARTICLES
            </span>
          </div>

          <motion.h2
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-normal text-brandDark max-w-4xl leading-tight"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.1 }}
          >
            Exclusive AI-Powered Idea &{" "}
            <span className="text-brandOrange">Automation</span> Services
          </motion.h2>
        </div>

        {/* Grid Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {articlesData.map((article) => (
            <React.Fragment key={article.id}>
              {/* Image Card */}
              <motion.div
                className="h-[220px] sm:h-[260px] lg:h-[300px] overflow-hidden rounded-3xl"
                initial={{ opacity: 0, y: 40, scale: 0.95 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: article.id * 0.1 }}
                whileHover={{ scale: 1.03 }}
              >
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                />
              </motion.div>

              {/* Content Card */}
              <motion.div
                className="bg-[#8B2E0E] p-6 sm:p-8 rounded-3xl flex flex-col justify-between h-auto lg:h-[300px]"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: article.id * 0.12 + 0.2 }}
                whileHover={{ y: -6 }}
              >
                <div>
                  <motion.h3
                    className="text-xl sm:text-2xl font-bold text-white mb-4 sm:mb-6 leading-tight"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{
                      duration: 0.7,
                      delay: article.id * 0.15 + 0.4,
                    }}
                  >
                    {article.title}
                  </motion.h3>

                  <motion.p
                    className="text-white/70 text-sm leading-relaxed mb-6 sm:mb-8"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{
                      duration: 0.7,
                      delay: article.id * 0.18 + 0.5,
                    }}
                  >
                    {article.description}
                  </motion.p>
                </div>

                <motion.button
                  className="flex items-center gap-2 text-white font-medium hover:gap-4 transition-all w-fit"
                  whileHover={{ x: 4 }}
                  whileTap={{ scale: 0.97 }}
                  transition={{ type: "spring", stiffness: 400, damping: 17 }}
                >
                  <span>More Details</span>
                  <FiArrowUpRight />
                </motion.button>
              </motion.div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Articles;
